/* src/app/billing/bill-table.component.css */
.pointer {
  cursor: pointer;
}
.pointer:hover {
  color: gray;
}
/*# sourceMappingURL=bill-table.component.css.map */
